import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@material-ui/core';
import FolderSelect from './FolderSelect';
import { KbFolder } from '../types';

interface Props {
  open: boolean;
  title: string;
  initialValue?: string;
  initialParentId: number | null;
  folders: KbFolder[];
  showFolderSelect: boolean;
  onConfirm: (value: string, parentId: number | null) => void;
  onCancel: () => void;
}

const FolderDialog: React.FC<Props> = ({ open, title, initialValue = '', initialParentId, folders, showFolderSelect, onConfirm, onCancel }) => {
  const [value, setValue] = useState(initialValue);
  const [parentId, setParentId] = useState<number | null>(initialParentId);

  React.useEffect(() => {
    if (open) {
      setValue(initialValue);
      setParentId(initialParentId);
    }
  }, [open, initialValue, initialParentId]);

  const handleSubmit = () => {
    if (value.trim()) {
      onConfirm(value.trim(), parentId);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {showFolderSelect && (
          <FolderSelect folders={folders} value={parentId} onChange={setParentId} />
        )}
        <TextField
          autoFocus
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          placeholder="Folder name..."
          margin="dense"
        />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={!value.trim()}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderDialog;
